import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import App from "./App";
import { leaseRoutes } from './lease_management/routes';
import PrivateRoute from "./hoc/PrivateRoute";
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { store } from "./store";
import PageLoader from "./shared_elements/PageLoader"; 
import { PageNotFound } from "./shared_elements";
import AuthSyncProvider from "./hoc/AuthSyncProvider";
import AiApp from "./AIChatBot/App";
import AiConsentGate from "./AIChatBot/AiConsentGate";
import TokenManagement from "./AIChatBot/TokenManagement";
import TokenUsage from "./AIChatBot/TokenUsage";
const root = ReactDOM.createRoot(document.getElementById("root"));

const UtilizationCRU = lazy(() => import("./lease_management/utilizations/components/UtilizationCRU"));
const UtilizationModule = lazy(() => import("./lease_management/utilizations/pages"));
const updatedLeaseRoutes = [
  ...leaseRoutes,
  {
    path: 'lease/:leaseSlug/utilization/:mode/:utilSlug?',
    component: () => (
      <Suspense fallback={<PageLoader />}>
        <UtilizationCRU />
      </Suspense>
    )
  },
  {
    path: 'lease/:leaseSlug/utilization',
    component: () => (
      <Suspense fallback={<PageLoader />}>
        <UtilizationModule />
      </Suspense>
    )
  }
];

root.render(
  <>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={3} autoHideDuration={5000} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
          <BrowserRouter>
            <AuthSyncProvider>
            <div className="body-wrapper">
              <Routes>
                <Route path="/" element={<App />}>
                  <Route index element={<Navigate to="/leases" replace />} />
                  {updatedLeaseRoutes.map((route, id) => (
                    <Route
                      key={id}
                      path={route.path}
                      element={
                        <PrivateRoute>
                          <route.component />
                        </PrivateRoute>
                      }
                    />
                  ))}
                  <Route
                    path="ai-chat"
                    element={
                      <PrivateRoute>
                        <AiConsentGate>
                          <AiApp />
                        </AiConsentGate>
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="ai-token-management"
                    element={
                      <PrivateRoute>
                        <AiConsentGate>
                          <TokenManagement />
                        </AiConsentGate>
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="ai-token-usage"
                    element={
                      <PrivateRoute>
                        <AiConsentGate>
                          <TokenUsage />
                        </AiConsentGate>
                      </PrivateRoute>
                    }
                  />
                </Route>
					      <Route path="*" element={<PageNotFound />} />
              </Routes>
            </div>
            </AuthSyncProvider>
          </BrowserRouter>
        </SnackbarProvider>
      </ThemeProvider>
    </Provider>
  </>
);